import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var CurrentUser = require("lib/account/CurrentUser");
var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var PaywallModal = require("components/users/teachers/PaywallModal");
var UIActions = require("lib/actions/UIActions");
var Features = require("lib/account/Features")

@connect(
	(state, props) => {
		// var prefs = RosterSelectors.studentListPrefs({ state }) || {};
		var prefs = {}
		var admin = RosterSelectors.admin({state, id: CurrentUser.get().id})
		
		if (admin && admin.prefs) {
			prefs = admin.prefs;
		}
		var hasLogReading = Features.isEnabled(Features.LOG_READING);
		return {
			prefs,
			hasLogReading
		}
	},

	(dispatch, props) => ({
		populateData: () => {
            //STEP 1: Grab logged in admin
            return Promise.all([ dispatch(RosterActions.fetchAdmins({
                filters:{ids: [CurrentUser.get().id]}, 
                embeds:['user.prefs'],
                cache: true
            }))])
        },
        showLogReadingPaywall: () =>
			dispatch(UIActions.showPaywall({ paywall: PaywallModal.LOG_READING })),
		onChange: (prefsUpdate, message) => {
			
			// RESETING ALL STUDENT LISTS
			var resetStudentLists = false

			if (confirm("Do you want to apply this setting to all your students? Selecting yes, will override the individual student and class preferences you may have set.") == true) {
				resetStudentLists = true
			} 

			window.wrNotifications.triggerDropDownNotification({
				title: "Information Edited", text: message, icon: "ok-sign"
			});

			return dispatch( RosterActions.updateAdminPrefs({
				id: CurrentUser.get().id,
				resetStudentLists: resetStudentLists,
				update: prefsUpdate
			}))
		},

	})
)

@providePopulateData({waitForLoad:true})
class BackLogReadingPreference extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	onBackLogChange(value) {
		if (!this.props.hasLogReading) {
			this.props.showLogReadingPaywall()
		} else {
			var prefsHash = { back_log_date_period: value }
			this.props.onChange(prefsHash, "You successfully changed the backlog reading setting.");	
		}
	}

	render() {
		return (
			<div>
				<p>
					Control whether your students can log reading for only today
					or up to seven days before today.
				</p>
				<div className="viewableScoreOptions">
					<label>
						<input type="radio" onChange={ this.onBackLogChange.bind(this, 7) }
							checked={ this.props.prefs.back_log_date_period == 7 } />
						Allow students to log reading for the previous week.
					</label><br />
					<label>
						<input type="radio" onChange={ this.onBackLogChange.bind(this, 1) }
							checked={ this.props.prefs.back_log_date_period == 1 } />
						Do not allow students to log reading for the last week (just today).
					</label>
				</div>	
			</div>
		)
	}
}

BackLogReadingPreference.WrappedComponent.propTypes = StrictPropTypes({
	prefs: PropTypes.object,
	// Handlers from @connect
	hasLogReading: PropTypes.bool,
	onChange: PropTypes.func.isRequired,
	showLogReadingPaywall: PropTypes.func,
	populateData: PropTypes.func.isRequired
});
module.exports = BackLogReadingPreference;


// WEBPACK FOOTER //
// ./modules/components/users/teachers/preferences/logs/BackLogReadingPreference.js